import store from "@/redux/store";
import { NotificationHolder } from "@/views/Notification/NotificationHolder";
import React from "react";
import { connect } from "react-redux";


class NotificationController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }

    async componentDidMount() {
    }
  
  render() {
    return (
        <>
        <NotificationHolder {...this.props}/>
        </>
    );
  }
}

const NotificationControllerInit = (props) => {
    const {notifications} = props;
  return (
    <NotificationController notifications={notifications.notifications}/>
  );
};

function mapStateToProps(state) {
    const {NotificationReducer} = state;
    
  return {
    notifications: NotificationReducer
  };
}

export default connect(mapStateToProps)(NotificationControllerInit);
